(function() {
  var STORAGE = {
    font: 'lev_font_size',
    contrast: 'lev_high_contrast',
    libras: 'lev_libras_enabled'
  };

  function save(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }

  function read(key, fallback) {
    try { return localStorage.getItem(key) || fallback; } catch (e) { return fallback; }
  }

  function setFont(size) {
    var html = document.documentElement;

    html.classList.remove('lev-font-large', 'lev-font-xlarge');
    if (size === 'large') html.classList.add('lev-font-large');
    if (size === 'xlarge') html.classList.add('lev-font-xlarge');

    save(STORAGE.font, size);
  }

  function setContrast(enabled) {
    document.documentElement.classList.toggle('lev-high-contrast', enabled);
    save(STORAGE.contrast, enabled ? '1' : '0');
  }

  function loadVLibras() {
    if (window.VLibras && window.VLibras.Widget) {
      startVLibras();
      return;
    }

    var existing = document.querySelector('script[data-lev-vlibras-script]');
    if (existing) {
      existing.addEventListener('load', startVLibras, { once: true });
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://vlibras.gov.br/app/vlibras-plugin.js';
    script.async = true;
    script.setAttribute('data-lev-vlibras-script', 'true');
    script.onload = startVLibras;
    document.body.appendChild(script);
  }

  function startVLibras() {
    if (window.__levVLibrasStarted || !window.VLibras || !window.VLibras.Widget) return;

    try {
      new window.VLibras.Widget('https://vlibras.gov.br/app');
      window.__levVLibrasStarted = true;
    } catch (e) {}
  }

  function setLibras(enabled) {
    if (!document.body) return;

    document.body.classList.toggle('lev-vlibras-hidden', !enabled);
    save(STORAGE.libras, enabled ? '1' : '0');

    if (enabled) loadVLibras();
  }

  function getPreferences() {
    return {
      font: read(STORAGE.font, 'normal'),
      contrast: read(STORAGE.contrast, '0') === '1',
      libras: read(STORAGE.libras, '0') === '1'
    };
  }

  var preferences = getPreferences();
  setFont(preferences.font);
  setContrast(preferences.contrast);

  function boot() {
    setLibras(preferences.libras);
  }

  window.LevAccessibility = {
    getPreferences: getPreferences,
    setFont: setFont,
    setContrast: setContrast,
    setLibras: setLibras
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
